module.exports = __webpack_public_path__ + "static/media/pay_parazula.1941cdaf.svg";